import React, { Component } from "react";
import "./submittedReportsStyles.css";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    IconButton,
} from "@material-ui/core";
import { Clear as ClearIcon } from "@material-ui/icons";

import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
export default class Filters extends Component {
    render() {
        const {
            users,
            user,
            jobStage,
            setJobStage,
            dateFrom,
            dateTo,
            setUser,
            setDateFrom,
            setYear,
            setMonth,
            year,
            month,
            setDateTo,
            jobID,
            setJobID,
        } = this.props;
        return (
            <>
                <FormControl style={{ minWidth: 200 }}>
                    <InputLabel>Filter By Users</InputLabel>
                    <Select
                        value={user === false ? "all_users" : user}
                        onChange={(event) => setUser(event.target.value)}
                    >
                        <MenuItem value="all_users">All Users</MenuItem>
                        {users &&
                            users.map((e) => {
                                return (
                                    <MenuItem value={e.uid} key={e.uid}>
                                        {e.user_name}
                                    </MenuItem>
                                );
                            })}
                    </Select>
                </FormControl>
                <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                    <InputLabel>Filter By Job Stage</InputLabel>
                    <Select
                        value={jobStage}
                        onChange={(event) => setJobStage(event.target.value)}
                    >
                        <MenuItem value="all_stages">All Reports</MenuItem>
                        <MenuItem value="Planning">Planning</MenuItem>
                        <MenuItem value="Preparation">Preparation</MenuItem>
                        <MenuItem value="Works">Works</MenuItem>
                        <MenuItem value="Aftercare">Aftercare</MenuItem>
                        <MenuItem value="Inspection & Monitoring">
                            Inspection & Monitoring
                        </MenuItem>
                        <MenuItem value="Complete">Complete</MenuItem>
                    </Select>
                </FormControl>
                <FormControl
                    style={{
                        marginLeft: 20,
                        minWidth: 200,
                        display: "initial",
                    }}
                >
                    <TextField
                        label="Filter By Job ID"
                        value={jobID === false ? "" : jobID}
                        onChange={(event) => {
                            setJobID(event.target.value);
                        }}
                    />
                    <IconButton>
                        <ClearIcon onClick={() => setJobID(false)} />
                    </IconButton>
                </FormControl>
                <FormControl
                    style={{
                        minWidth: 200,
                        display: "initial",
                    }}
                >
                    <TextField
                        label="Filter By Year"
                        value={year === false ? "" : year}
                        onChange={(event) => {
                            setYear(event.target.value);
                        }}
                    />
                </FormControl>
                <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                    <InputLabel>Filter By Month</InputLabel>
                    <Select
                        value={month}
                        onChange={(event) => {
                            setMonth(event.target.value);
                        }}
                    >
                        <MenuItem value="select">Select Month</MenuItem>
                        <MenuItem value="jan">January</MenuItem>
                        <MenuItem value="feb">February </MenuItem>
                        <MenuItem value="mar">March</MenuItem>
                        <MenuItem value="apr">April</MenuItem>
                        <MenuItem value="may">May</MenuItem>
                        <MenuItem value="jun">June</MenuItem>
                        <MenuItem value="jul">July</MenuItem>
                        <MenuItem value="aug">August</MenuItem>
                        <MenuItem value="sep">September</MenuItem>
                        <MenuItem value="oct">October</MenuItem>
                        <MenuItem value="nov">November</MenuItem>
                        <MenuItem value="dec">December</MenuItem>
                    </Select>
                </FormControl>
                <div id="datePickers" style={{ float: "left" }}>
                    <DayPickerInput
                        id="dateFrom"
                        value={dateFrom === false ? "" : dateFrom}
                        placeholder="Select Week"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        format="DD-MM-YYYY"
                        onDayChange={(day) => {
                            let df = moment(day).startOf("week").toDate();
                            let dt = moment(day).endOf("week").toDate();
                            setDateFrom(df);
                            setDateTo(dt);
                        }}
                    />

                    <p>-</p>
                    <DayPickerInput
                        value={dateTo === false ? "" : dateTo}
                        placeholder="End Date"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        format="DD-MM-YYYY"
                        onDayChange={(day) => setDateTo(day)}
                    />

                    <IconButton
                        style={{
                            marginLeft: "5px",
                            marginTop: "-3px",
                            color: "red",
                            border: "1px solid red",
                        }}
                        color="primary"
                        variant="outlined"
                        onClick={() => {
                            setDateFrom();
                            setDateTo();
                        }}
                    >
                        <ClearIcon />
                    </IconButton>
                </div>
            </>
        );
    }
}
